import { Tab, Tabs } from 'symbiosis-uikit'
import { Link, matchPath, useLocation } from 'react-router-dom'
import { CONFIG } from '~/lib/config'

function useRouteMatch(patterns) {
	const { pathname } = useLocation()

	for (let i = 0; i < patterns.length; i += 1) {
		const pattern = patterns[i]
		const possibleMatch = matchPath(pattern, pathname)
		if (possibleMatch !== null) {
			return possibleMatch
		}
	}

	return null
}

function HeaderTabs() {
	const routeMatch = useRouteMatch([
		'/crosschain-farm',
		'/crosschain-farm-v2',
		'/lp-farm/:earnTypePath/:page',
		'/vesis/*',
	])
	const currentTab = routeMatch?.pattern?.path

	return (
		<Tabs value={currentTab}>
			<Tab as={Link} value="/crosschain-farm-v2" to="/crosschain-farm-v2">
				Farm
			</Tab>
			<Tab
				as={Link}
				value="/lp-farm/:earnTypePath/:page"
				to="/lp-farm/:earnTypePath/:page"
			>
				LP Farm
			</Tab>
			<Tab
				as={Link}
				value="/vesis/*"
				to={`/vesis/${CONFIG.vesis[0].slug}`}
			>
				veSIS
			</Tab>
		</Tabs>
	)
}

export default HeaderTabs
